import React, { Fragment } from 'react'
import { Card, Col, Label, FormGroup, Row, CardBody, CardHeader, Input, Button } from 'reactstrap';
import Datetime from 'react-datetime';
import { useInformedConsent } from '../../hooks/InformedConsent/useInformedConsent';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';


export const IndexInformedConsent = () => {

    const {
        //? DATA 
        date_ini, date_end, searchNim, searchName, handleClean,
        handleChangeValue,
        handleFilter,
        listInformedConsent,
        printPdfConsentInformed,
        nextPage, previousPage, totalPageCount, currentPage, goToPage,
        loadingPreviewId, pdfPreviewUrl, showPreview, handleOpenPreview, setShowPreview, loadingDownloadId,
        loadingFilters,

        searchTerm,
        handleSearch,
        handleClearSearch,
        filteredInformedConsent

    } = useInformedConsent();


    const divStyle = {
        backgroundColor: "#46afe5",
        borderColor: "#46afe5",
        color: "#fff",
        textAlign: "center",
        cursor: "pointer",
        padding: "8px 16px",
    };



    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };


    return (
        <Fragment>
            <div className='container-global-zoom p-3'>

                <Card style={{
                    marginBottom: "15px",
                    background: "linear-gradient(135deg, #002940 0%, #1d5b83 100%)",
                    border: "none",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                }}>
                    <CardBody style={{ padding: "10px 25px" }}>
                        <div className="d-flex align-items-center">
                            <img
                                alt="flask"
                                src={require("../../assets/images/consentimientoI.svg")}
                                style={{ width: "60px", height: "60px", marginRight: "15px" }}
                            />

                            <div style={{ textAlign: "left" }}>
                                <h4 className="mb-1" style={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
                                    Consentimiento informado
                                </h4>

                                <small style={{ color: "rgba(255,255,255,0.85)", fontSize: "13px" }}>
                                    <i className="fa fa-info-circle mr-1"></i>
                                    Acceder y descargar los consentimientos informados que fueron respondidos durante la toma de muestra.
                                </small>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                <Card>
                    <Col sm="12" className="pt-3">
                        <Row>
                            <Col sm="2" className="p-l-0 p-r-0" style={{ textAlign: "left" }}>
                                <Card style={{
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                    border: "none",
                                    borderRadius: "12px"
                                }}>
                                    <CardHeader style={{
                                        background: "linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)",
                                        color: "white",
                                        padding: "15px",
                                        borderRadius: "12px 12px 0 0"
                                    }}>
                                        <h6 className="mb-0" style={{ fontWeight: 700, fontSize: "15px" }}>
                                            <i className="fa fa-filter mr-2"></i>
                                            Filtros de búsqueda
                                        </h6>
                                    </CardHeader>

                                    <CardBody style={{ padding: "18px" }}>

                                        <FormGroup>
                                            <Label className="f-w-600 label-report">
                                                <i className="fa fa-calendar mr-2" style={{ color: "#1d5b83" }}></i>
                                                Fecha de inicio
                                            </Label>

                                            <Input
                                                type="date"
                                                value={date_ini}
                                                name="date_ini"
                                                onChange={handleChangeValue}
                                                style={{ borderRadius: "8px", fontSize: "12px" }}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label className="f-w-600 label-report">
                                                <i className="fa fa-calendar-check mr-2" style={{ color: "#28a745" }}></i>
                                                Fecha de cierre
                                            </Label>

                                            <Input
                                                type="date"
                                                value={date_end}
                                                name="date_end"
                                                onChange={handleChangeValue}
                                                style={{ borderRadius: "8px", fontSize: "12px" }}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label className="f-w-600 label-report">
                                                <i className="fa fa-hashtag mr-2" style={{ color: "#1d5b83" }} />
                                                NIM
                                            </Label>

                                            <Input
                                                type="text"
                                                name="searchNim"
                                                value={searchNim}
                                                onChange={handleChangeValue}
                                                placeholder="Buscar por NIM"
                                                style={{ borderRadius: "8px", fontSize: "12px" }}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label className="f-w-600 label-report">
                                                <i className="fa fa-user mr-2" style={{ color: "#1d5b83" }} />
                                                Nombre del paciente
                                            </Label>

                                            <Input
                                                type="text"
                                                name="searchName"
                                                value={searchName}
                                                onChange={handleChangeValue}
                                                placeholder="Nombre y apellidos"
                                                style={{ borderRadius: "8px", fontSize: "12px" }}
                                            />
                                        </FormGroup>

                                        <br />
                                        <b>Acciones</b>
                                        <br /><br />

                                        <Button
                                            onClick={handleFilter}
                                            // disabled={loading}
                                            color="primary"
                                            block
                                            outline
                                            className="mb-2"
                                            style={{ borderRadius: "10px", padding: "6px", fontSize: "13px", fontWeight: 600 }}
                                        >
                                            Buscar
                                        </Button>

                                        <Button
                                            onClick={handleClean}
                                            // disabled={loading}
                                            color="danger"
                                            block
                                            outline
                                            className="mb-2"
                                            style={{ borderRadius: "10px", padding: "6px", fontSize: "13px", fontWeight: 600 }}
                                        >
                                            <i className="fa fa-eraser mr-2"></i>
                                            Limpiar
                                        </Button>

                                    </CardBody>
                                </Card>
                            </Col>

                            <Col sm="10">
                                <div
                                    style={{
                                        position: "relative",
                                        width: "100%",
                                        height: "50px"
                                    }}
                                >
                                    <div
                                        className="ribbon ribbon-clip ribbon-primary"
                                        style={{
                                            top: "8px",
                                            left: "0px",
                                            zIndex: 10
                                        }}
                                    >
                                        Consentimiento informado
                                    </div>

                                    <div
                                        style={{
                                            position: "absolute",
                                            right: "0",
                                            top: "5px",
                                            width: "280px"
                                        }}
                                    >
                                        <div
                                            className="report-general-search"
                                            style={{ position: "relative" }}
                                        >
                                            <i className="pi pi-search"></i>

                                            <Input
                                                type="text"
                                                placeholder="Buscar por NIM, nombre o fecha..."
                                                value={searchTerm}
                                                onChange={handleSearch}
                                                style={{
                                                    paddingRight: searchTerm ? "35px" : "12px"
                                                }}
                                            />

                                            {searchTerm && (
                                                <button
                                                    type="button"
                                                    onClick={handleClearSearch}
                                                    title="Limpiar búsqueda"
                                                    className="informed-consent-clear-search"
                                                >
                                                    <i className="pi pi-times"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                  
                                    <DataTable
                                        value={filteredInformedConsent}
                                        loading={loadingFilters}
                                        loadingIcon="pi pi-spin pi-spinner"
                                        paginator
                                        rows={10}
                                        rowsPerPageOptions={[10, 50, 100]}
                                        responsiveLayout="scroll"
                                        className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "40%" }}
                                                        alt="Sin información"
                                                    />
                                                    <br />
                                                    <p
                                                        className="badge badge-light-primary mt-2"
                                                        style={{ fontSize: "15px" }}
                                                    >
                                                        Sin información.
                                                    </p>
                                                </div>
                                            }
                                    >



                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="nim" header="Nim" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="name" header="Nombre" sortable headerStyle={headerStyle} style={cellStyle} />
                                        {/* <Column field="surnames" header="Apellidos" sortable headerStyle={headerStyle} style={cellStyle} /> */}
                                        <Column field="date" header="Fecha" headerStyle={headerStyle} style={cellStyle} />


                                        <Column
                                            header="Acciones"
                                            headerStyle={headerStyle}
                                            style={{ ...cellStyle, textAlign: "center" }}
                                            body={(rowData) => (
                                                <div className="d-flex justify-content-center gap-2">
                                                    <button
                                                        onClick={() => printPdfConsentInformed(rowData.nim)}
                                                        title="Descargar"
                                                        disabled={loadingDownloadId === rowData.nim}
                                                        style={{
                                                            width: "30px",
                                                            height: "30px",
                                                            fontSize: "0.65rem",
                                                            borderRadius: "8px",
                                                            padding: "0",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                        className="btn btn-danger mr-1"
                                                    >
                                                        {loadingDownloadId === rowData.nim ? (
                                                            <i className="fa fa-spinner fa-spin"></i>
                                                        ) : (
                                                            <i className="fa fa-file-pdf-o"></i>


                                                        )}
                                                    </button>
                                                    <button
                                                        onClick={() => handleOpenPreview(rowData.nim)}
                                                        title="Previsualizar Cotización"
                                                        disabled={loadingPreviewId === rowData.nim}
                                                        style={{
                                                            width: "30px",
                                                            height: "30px",
                                                            fontSize: "0.65rem",
                                                            borderRadius: "8px",
                                                            padding: "0",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                        className="btn btn-primary"
                                                    >
                                                        {loadingPreviewId === rowData.nim ? (
                                                            <i className="fa fa-spinner fa-spin"></i>
                                                        ) : (
                                                            <i className="icofont icofont-ui-search"></i>
                                                        )}
                                                    </button>
                                                </div>
                                            )}
                                        />
                                    </DataTable>
                                </div> 
                            </Col>
                        </Row>
                    </Col>
                </Card>
                <Dialog
                    header="Previsualización de PDF"
                    visible={showPreview}
                    style={{ width: '60vw', maxWidth: '700px' }}
                    modal
                    dismissableMask
                    onHide={() => setShowPreview(false)}
                    headerStyle={{
                        backgroundColor: '#0d3b59',
                        color: 'white',
                        fontWeight: 'bold',
                    }}
                    pt={{
                        header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                        headerIcon: { style: { color: 'white' } },
                    }}
                >
                    {pdfPreviewUrl && (
                        <iframe
                            src={pdfPreviewUrl}
                            title="PDF Preview"
                            width="100%"
                            height="600px"
                            style={{ border: "none" }}
                        />
                    )}
                </Dialog>
            </div>
        </Fragment>
    )
}
